import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class PlatformPosterManageAPI extends BasicsClass {
    public apiUrls: any = new Map([
        // ['forbideenPlatformPosterAccount', {
        //     url: '/user/forbid',
        //     name: 'account-forbid',
        //     label: '账户封禁'
        // }],
        ['getPlatformPosterTableList', {
            url: '/admin/poster/platform/list',
            name: 'list',
            label: '列表'
        }],

        ['addPlatformPoster', {
            url: '/admin/poster/platform/upload',
            name: 'add-platform-poster',
            label: '添加平台海报'
        }],

        // ['editPlatformPoster', {
        //     url: '/admin/light/edit',
        //     name: 'edit-platform-poster',
        //     label: '编辑平台海报'
        // }],

        ['delPlatformPoster', {
            url: '/admin/poster/platform/delete',
            name: 'delete-platform-poster',
            label: '删除平台海报'
        }],

        ['pulishPlatformPoster', {
            url: '/admin/poster/platform/release',
            name: 'publish-platform-poster',
            label: '发布平台海报'
        }]
        // ['getPlatformPosterDetail', {
        
        
        //     name: 'detail',
        //     label: '详情',
        //     // hidden: true
        // }]
    ])


    // // 平台海报列表
    public getPlatformPosterTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getPlatformPosterTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // // 添加平台海报
    public addPlatformPoster(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('addPlatformPoster').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 编辑平台海报
    // public editPlatformPoster(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //   const apiUrls = this.apiUrls

    //   const url = apiUrls.get('editPlatformPoster').url

    //   this.BasicPost(url, {
    //       ...params
    //   }, false, false, false, successCb, failCb, showLoading)
    // }

    // 删除平台海报
    public delPlatformPoster(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('delPlatformPoster').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 发布平台海报
    public pulishPlatformPoster(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('pulishPlatformPoster').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }
}